<template>
  <section class="ut-detalle-turno" :class="{ 'ut-turno-ampliado': !compacto }" aria-label="Datos del turno">
    <h3>{{ registro.numero_viaje || numeroViaje(registro) }}</h3>
    <dl>
      <div v-for="campo in campos" :key="campo.titulo"><dt>{{ campo.titulo }}</dt><dd>{{ campo.valor }}</dd></div>
    </dl>
    <template v-if="!compacto">
      <v-alert v-if="tieneMovimientos" type="warning" outlined dense>No puede modificar este turno porque ya tiene movimientos.</v-alert>
      <table aria-label="Movimientos del turno"><thead><tr><th>Movimiento</th><th>Cantidad</th></tr></thead>
        <tbody><tr v-for="grupo in movimientos" :key="grupo.campo"><th>{{ grupo.titulo }}</th><td>{{ grupo.total }}</td></tr></tbody>
      </table>
    </template>
  </section>
</template>
<script>
import { esVerdadero, tieneValor, formatear } from './catalogo';
import { fechaDetalle } from './detalleVenta';
import { numeroViaje } from './BuscarTurnoUtilitario.vue';
export default {
  name: 'DetalleTurno',
  props: { datos: { type: Object, required: true }, compacto: Boolean },
  computed: {
    registro() { return this.datos.registro || {}; },
    tieneMovimientos() { return esVerdadero(this.datos.detalles && this.datos.detalles.tiene_movimiento); },
    campos() {
      const r = this.registro;
      return [['Fecha', fechaDetalle(r.fecha_presentacion || r.fecha, true)], ['Hora', r.hora], ['Sentido', esVerdadero(r.es_sentido_ida) ? 'Ida' : 'Vuelta'],
        ['Ficha', r.ficha], ['Vehiculo', r.descripcion_vehiculo], ['Chofer', r.conductor], ['Activo', formatear(r.turno_activo, 'booleano')], ['Cerrado', formatear(r.turno_cerrado, 'booleano')]]
        .map(([titulo, valor]) => ({ titulo, valor: tieneValor(valor) ? valor : 'No registrado' }));
    },
    movimientos() {
      const detalles = this.datos.detalles || {};
      return [['tickets_vendidos', 'Boletos vendidos'], ['tickets_abordados', 'Boletos abordados'], ['envios', 'Envios'], ['cierres', 'Cierres de viaje activos'], ['pagos', 'Pagos entre sucursales']]
        .map(([campo, titulo]) => ({ campo, titulo, total: detalles[campo] ? Number(detalles[campo].total) || 0 : 'No disponible' }));
    },
  },
  methods: { numeroViaje },
};
</script>
<style scoped>
.ut-detalle-turno { color: #263644; font-size: 14px; letter-spacing: 0; }
.ut-turno-ampliado { padding: 20px; }
.ut-detalle-turno h3 { font-size: 18px; margin: 0 0 16px; overflow-wrap: anywhere; }
.ut-detalle-turno dl { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 16px; margin: 0 0 20px; }
.ut-detalle-turno dt { font-size: 12px; color: #536575; }
.ut-detalle-turno dd { margin: 3px 0 0; overflow-wrap: anywhere; }
.ut-detalle-turno table { border-collapse: collapse; width: 100%; }
.ut-detalle-turno th, .ut-detalle-turno td { padding: 8px; border-bottom: 1px solid #d5dce1; text-align: left; font-weight: normal; }
.ut-detalle-turno thead { background: #edf2f5; }
.ut-detalle-turno td { text-align: right; }
@media (max-width: 600px) { .ut-detalle-turno dl { grid-template-columns: repeat(2, minmax(0, 1fr)); } }
</style>
